import React, { useEffect, useState } from 'react';
import { SparklesIcon } from 'lucide-react';
const LOADING_MESSAGES = ['Creating your mood journey…', 'Crafting the perfect energy…', 'Finding tracks to transform your mood…', 'Almost ready to elevate your spirit…'];
export const MoodMixLoading = () => {
  const [messageIndex, setMessageIndex] = useState(0);
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
  // Check if device is mobile
  useEffect(() => {
    const checkIfMobile = () => {
      setIsMobile(window.innerWidth < 768);
    };
    window.addEventListener('resize', checkIfMobile);
    return () => window.removeEventListener('resize', checkIfMobile);
  }, []);
  useEffect(() => {
    const interval = setInterval(() => {
      setMessageIndex(prev => (prev + 1) % LOADING_MESSAGES.length);
    }, 2000);
    return () => clearInterval(interval);
  }, []);
  return <div className="fixed inset-0 z-50 flex items-center justify-center bg-black" data-id="element-237">
      <div className="text-center px-4" data-id="element-238">
        <div className="mb-8 relative flex justify-center" data-id="element-239">
          <div className="w-16 h-16 rounded-full bg-gradient-to-br from-purple-600 via-blue-500 to-green-400 animate-pulse" data-id="element-240"></div>
          <SparklesIcon className="w-8 h-8 text-white absolute -right-4 -top-4 animate-bounce" data-id="element-241" />
        </div>
        <p className={`${isMobile ? 'text-xl' : 'text-2xl'} font-bold animate-fade-in`} data-id="element-242">
          {LOADING_MESSAGES[messageIndex]}
        </p>
      </div>
    </div>;
};